import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38583768"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "半製成品相完成了！")
], -1))
const _hoisted_2 = { class: "ion-padding-vertical" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "您的 貴婦犬 特徵備註", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "您的 巴哥犬 特徵備註", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "木名牌資料", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode()
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr" }, null, -1))
const _hoisted_10 = { lass: "ion-padding-vertical" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 開啟新檔案")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 加入購物車")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 付款 HKD 0")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "back-text" }, "返回", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 檔案名稱 ")
const _hoisted_17 = { class: "ion-padding-vertical ion-text-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode("木名牌資料")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "最多 15個字", -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" OK!")
const _hoisted_22 = { class: "ion-padding-vertical ion-text-center" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("您未完成為寵物填寫資料")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 返回")
const _hoisted_25 = { class: "ion-padding-vertical ion-text-center" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("已成功加入購物車")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 好的")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_back_button, {
                        class: "back-icon",
                        "default-href": "/new-design"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "primary" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        color: "primary",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.shareCanvas()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.share
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_ion_card),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ion_button, {
              fill: "clear",
              expand: "block",
              style: {"color":"#333"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openPostQuestionModal()))
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_ion_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      class: "info-icon",
                      icon: $setup.arrowForward
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_4,
            _createVNode(_component_ion_button, {
              fill: "clear",
              expand: "block",
              style: {"color":"#333"}
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_ion_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      class: "info-icon",
                      icon: $setup.arrowForward
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_6,
            _createVNode(_component_ion_button, {
              fill: "clear",
              expand: "block",
              style: {"color":"#333"}
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8,
                _createVNode(_component_ion_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      class: "info-icon",
                      icon: $setup.arrowForward
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_ion_button, {
              fill: "outline",
              expand: "block",
              class: "info-button",
              shape: "round"
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _createVNode(_component_ion_icon, { icon: $setup.pencil }, null, 8, ["icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              fill: "outline",
              expand: "block",
              class: "info-button",
              shape: "round"
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _createVNode(_component_ion_icon, { icon: $setup.cart }, null, 8, ["icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              expand: "block",
              class: "info-button",
              shape: "round"
            }, {
              default: _withCtx(() => [
                _hoisted_13,
                _createVNode(_component_ion_icon, { icon: $setup.card }, null, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          _hoisted_14,
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        fill: "clear",
                        solt: "start"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            class: "back-icon",
                            icon: $setup.arrowBack
                          }, null, 8, ["icon"]),
                          _hoisted_15
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_title, { "text-center": "" }, {
                        default: _withCtx(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        fill: "clear",
                        solt: "end",
                        class: "icon-share"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: $setup.share }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        fill: "clear",
                        solt: "end",
                        class: "icon-save"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: $setup.save }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_ion_icon, {
              class: "icon-close",
              icon: $setup.close
            }, null, 8, ["icon"]),
            _hoisted_18,
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }),
            _hoisted_20,
            _createVNode(_component_ion_input, { placeholder: "例子：B仔，生日快樂！" }),
            _createVNode(_component_ion_button, {
              class: "info-button",
              size: "large",
              shape: "round"
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              class: "info-button",
              shape: "round"
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _hoisted_26
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              class: "info-button",
              shape: "round"
            }, {
              default: _withCtx(() => [
                _hoisted_27
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}